import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {DashboardQueryService} from '../../../shared/services/dashboard-query.service';
import {SpiUtils} from '../../../shared/services/spi.utils';



@Component({
  selector: 'app-chart-bar',
  templateUrl: './chart-bar.component.html',
  styleUrls: ['./chart-bar.component.scss']
})
export class ChartBarComponent implements OnInit, OnDestroy, OnChanges {

  @Input() year: number;
  @Input() queryName: string;
  @Input() selectedCentreId = -1;
  @Input() productId = -1;


  loading = false;

  options: any;
  private: number;

  constructor(private dashboardQueryService: DashboardQueryService) {}

  ngOnInit(): void {
  }
  drawChart() {
    setTimeout (() => {
      if (!this.selectedCentreId) {
        this.selectedCentreId = -1;
      }
      const parameters = [
        {key : 'year', value: this.year},
        {key : 'centerId', value: this.selectedCentreId}
      ];
      this.loading = true;
      this.dashboardQueryService.runQuery(this.queryName, parameters)
        .subscribe(data => {

          if (this.queryName === 'BP_QUANTITY_PRIX_SEMAINE') {
            if (data && data.length > 0) {

              const xAxisData = [];
              const data1 = [];
              const data2 = [];

              data.forEach(obj => {
                xAxisData.push(obj.dat);
                data1.push(obj['Prix Total']);
                data2.push(obj['Quantité']);
              });

              this.options = {
                toolbox: {
                  'show': true,
                  'showTitle': true,
                  'feature': {
                    'mark': {
                      'show': true
                    },
                    'dataView': {
                      'show': true,
                      'readOnly': false,
                      'title': 'Afficher les données',
                      'lang': [
                        'Vue des données',
                        'Fermer',
                        'Rafraîchir'
                      ]
                    },
                    'magicType': {
                      'show': true,
                      'type': [
                        'line',
                        'bar'
                      ],
                      'title': {
                        'line': 'for line chartsA',
                        'bar': 'for bar charts'
                      }
                    },
                    'restore': {
                      'show': true,
                      'title': 'restore'
                    },
                    'saveAsImage': {
                      'show': true,
                      'title': 'save as image',
                      'lang': [
                        'Right-click to save as picture'
                      ]
                    }
                  },
                  'tooltip': {
                    'show': false,
                    'backgroundColor': '#222',
                    'textStyle': {
                      'fontSize': 12
                    },
                    'extraCssText': 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
                  }
                },
                legend: {
                  data: ['Prix Total TND', 'Quantité QX'],
                  show: true,
                  bottom: 5,
                  type: 'scroll',
                },
                'grid': {
                  'left': 15,
                  'right': 25,
                  'top': 75,
                  'bottom': 60,
                  'containLabel': true
                },
                'dataZoom': {
                  'show': true,
                  'start': 0,
                  'end': 100,
                  'bottom': 30,
                  'handleSize': 25
                },
                tooltip: {},
                xAxis: {
                  data: xAxisData,
                  silent: false,
                  splitLine: {
                    show: false,
                  },
                },
                yAxis: [
                  {
                    'type': 'value',
                    'id': '0',
                    name: '(TND)'
                  },
                  {
                    'type': 'value',
                    name: '(QX)',
                    'id': '1'
                  }
                ],
                series: [
                  {
                    name: 'Prix Total TND',
                    type: 'bar',
                    data: data1,
                    animationDelay: idx => idx * 10,
                  },
                  {
                    name: 'Quantité QX',
                    yAxisIndex: 1,
                    type: 'bar',
                    data: data2,
                    animationDelay: idx => idx * 10 + 100,
                  },
                ],
                animationEasing: 'elasticOut',
                animationDelayUpdate: idx => idx * 5,
              };
            }
          }

          if (this.queryName === 'BR_PAR_JOUR') {
            if (data && data.length > 0) {

              const xAxisData = [];
              const data1 = [];
              const data2 = [];

              data.forEach(obj => {
                xAxisData.push(obj.reception_date);
                data1.push(obj.count);
                data2.push(obj.sum);
              });

              this.options = {
                toolbox: {
                  'show': true,
                  'showTitle': true,
                  'feature': {
                    'mark': {
                      'show': true
                    },
                    'dataView': {
                      'show': true,
                      'readOnly': false,
                      'title': 'Afficher les données',
                      'lang': [
                        'Vue des données',
                        'Fermer',
                        'Rafraîchir'
                      ]
                    },
                    'magicType': {
                      'show': true,
                      'type': [
                        'line',
                        'bar'
                      ],
                      'title': {
                        'line': 'for line chartsA',
                        'bar': 'for bar charts'
                      }
                    },
                    'restore': {
                      'show': true,
                      'title': 'restore'
                    },
                    'saveAsImage': {
                      'show': true,
                      'title': 'save as image',
                      'lang': [
                        'Right-click to save as picture'
                      ]
                    }
                  },
                  'tooltip': {
                    'show': false,
                    'backgroundColor': '#222',
                    'textStyle': {
                      'fontSize': 12
                    },
                    'extraCssText': 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
                  }
                },
                legend: {
                  data: ['Nombre BR', 'Total (QL)'],
                  show: true,
                  bottom: 5,
                  type: 'scroll',
                },
                'grid': {
                  'left': 15,
                  'right': 25,
                  'top': 75,
                  'bottom': 60,
                  'containLabel': true
                },
                'dataZoom': {
                  'show': true,
                  'start': 80,
                  'end': 100,
                  'bottom': 30,
                  'handleSize': 25
                },
                tooltip: {},
                xAxis: {
                  data: xAxisData,
                  silent: false,
                  splitLine: {
                    show: false,
                  },
                },
                yAxis: [
                  {
                    'type': 'value',
                    'id': '0'
                  },
                  {
                    'type': 'value',
                    name: '(QL)',
                    'id': '1'
                  }
                ],
                series: [
                  {
                    name: 'Nombre BR',
                    type: 'bar',
                    data: data1,
                    animationDelay: idx => idx * 10,
                  },
                  {
                    name: 'Total (QL)',
                    yAxisIndex: 1,
                    type: 'bar',
                    data: data2,
                    animationDelay: idx => idx * 10 + 100,
                  },
                ],
                animationEasing: 'elasticOut',
                animationDelayUpdate: idx => idx * 5,
              };
            }
          }

          if (this.queryName === 'PRIX_ACHAT_MOYEN_PONDERE') {
            if ( data && data.length > 0 ) {

              const category = [];
              const dataSerie = [];

              data.forEach( obj => {
                dataSerie.push(obj.pmap);
                category.push(obj.name);
              });

              this.options = {
                toolbox: {
                  'show': true,
                  'showTitle': true,
                  'feature': {
                    'mark': {
                      'show': true
                    },
                    'dataZoom': {
                      'show': true,
                      'title': {
                        'zoom': 'area zooming',
                        'back': 'Restaurer le zoom de la zone'
                      }
                    },
                    'dataView': {
                      'show': true,
                      'readOnly': false,
                      'title': 'Afficher les données',
                      'lang': [
                        'Vue des données',
                        'Fermer',
                        'Rafraîchir'
                      ]
                    },
                    'magicType': {
                      'show': true,
                      'type': [
                        'line',
                        'bar'
                      ],
                      'title': {
                        'line': 'for line chartsA',
                        'bar': 'for bar charts'
                      }
                    },
                    'restore': {
                      'show': true,
                      'title': 'restore'
                    },
                    'saveAsImage': {
                      'show': true,
                      'title': 'save as image',
                      'lang': [
                        'Right-click to save as picture'
                      ]
                    }
                  },
                  'tooltip': {
                    'show': false,
                    'backgroundColor': '#222',
                    'textStyle': {
                      'fontSize': 12
                    },
                    'extraCssText': 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
                  }
                },
                legend: {
                  data: ['Prix Moyen Ponderé (TND)'],
                  show: true,
                  bottom: 5,
                  type: 'scroll'
                },
                'grid': {
                  'left': 15,
                  'right': 25,
                  'top': 75,
                  'bottom': 60,
                  'containLabel': true
                },
                tooltip: {},
                xAxis: {
                  type: 'category',
                  data: category
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                  {
                    name: 'Prix Moyen Ponderé (TND)',
                    data: dataSerie,
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                      color: 'rgba(180, 180, 180, 0.2)'
                    }
                  }
                ]
              };
            }
          }

          this.loading = false;
        }, err => {
          console.log(err);
        });
    }, 500);
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.drawChart();

  }

  ngOnDestroy(): void {
  }
}
